export class Subject {
  materia: String;
  institucion: number;
  nombrePrograma: String;
  periodo: String;
  creditos: number;
  calificacion: String;
  comentario: String;
  codMateria: number;
  codPrograma: number;
  version: string;
  intensidad: number;
  consecutivo: String;
}
